export default __webpack_public_path__ + "static/media/facebook.07121d79.svg";